import { Forum } from '@mui/icons-material';
import { Typography, useTheme } from '@mui/material';
import { blue } from '@mui/material/colors';
import { mapScreenTypeToSectionType } from '#helpers/enumMappers.ts';
import { useActiveReviewsDrawer } from '#hooks/useActiveReviewsDrawer.ts';
import { tt } from '#i18n/index.ts';
import { Container, InnerContainer } from './styled.ts';
import { type ComponentProps } from './types.ts';

export const Component = ({ compact, id, reviews, sx = {}, type }: ComponentProps) => {
  const [, setActiveReviewsDrawer] = useActiveReviewsDrawer();
  const theme = useTheme();

  return (
    <>
      <Container
        aria-label={tt('reviewsBadge.ariaLabel')}
        onClick={() => {
          if (reviews > 0) {
            setActiveReviewsDrawer({ id, type: mapScreenTypeToSectionType(type) });
          }
        }}
        reviews={reviews}
        sx={sx}
      >
        {compact ? undefined : (
          <Typography
            sx={{
              [theme.breakpoints.down('sm')]: {
                display: 'none',
              },
              color: theme.supportingTextPrimary,
              fontSize: '0.75rem',
              textAlign: 'center',
            }}
          >
            {tt('reviewsBadge.title').toUpperCase()}
          </Typography>
        )}
        <InnerContainer>
          <Forum
            sx={{
              color: blue[500],
              fontSize: '2.5rem',
              marginRight: theme.spacing(0.5),
              width: compact ? '35px' : undefined,
            }}
          />
          <Typography
            sx={{
              color: theme.mainTextPrimary,
              display: 'inline-block',
            }}
            variant="h6"
          >
            <strong>{reviews.toLocaleString()}</strong>
          </Typography>
        </InnerContainer>
      </Container>
    </>
  );
};
